// Small (?) button rendered next to a field label; opens the field's
// explanation modal (see TenderSearchProfilesPanel).

import { HelpCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function FieldHelpButton({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      aria-label={t("tenderSearchProfiles.help.open")}
      title={t("tenderSearchProfiles.help.open")}
      className="inline-flex cursor-pointer items-center justify-center rounded p-0.5 text-muted-foreground hover:text-foreground"
      onClick={onClick}
    >
      <HelpCircle size={14} />
    </button>
  );
}
